module.exports = __webpack_public_path__ + "media/bootstrap-icons/pip-f3948edb.svg";